import ToggleFloatButton from 'components/ToggleFloatButton'
import React from 'react'

interface ReservationActionsProps {
  handleClickRescheduleOption: () => void
  handleClickCancelOption: () => void
}

export const ReservationActions: React.FC<ReservationActionsProps> = ({ 
  handleClickRescheduleOption, 
  handleClickCancelOption 
}) => {
  const options = [
    { code: 1, name: 'Remarcar', func: handleClickRescheduleOption },
    { code: 2, name: 'Cancelar', func: handleClickCancelOption }
  ]

  return (
    <div>
      <ToggleFloatButton menuList={options} iconName='MoreOptions' />
    </div>
  )
}